import React, { useState } from "react";
import { ReactComponent as ImageIcon } from "../../../../assets/image-rectangle.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/trash.svg";

// Skeleton Loader Component
const SkeletonLoader = () => (
  <div className="h-[80px] md:h-[200px] bg-gray-300 animate-pulse rounded-lg"></div>
);

function ImageUpload({ images, handleImageUpload, handleDeleteImage, title }) {
  const [loading, setLoading] = useState(false);

  return (
    <section>
      <h4 className="text-[#24252D] font-medium text-base mt-[20px] mb-2">
        {title}
      </h4>
      <div className="row">
        <div className="col-lg-4 col-md-6 col-12 mb-3">
          <div
            className="h-[200px] bg-[#F5F6FA] relative border-2 border-gray-300 border-dashed rounded-lg flex items-center justify-center"
            id="dropzone"
          >
            <input
              type="file"
              multiple
              accept=".png, .jpg"
              className="absolute w-full h-full opacity-0 z-50"
              onChange={handleImageUpload}
            />
            <div className="text-center flex flex-col items-center justify-center">
              <ImageIcon />
              <span className="text-[#515B6B] font-medium">Upload image</span>
              <p className="mt-[5px] text-[10px] text-[#515B6B]">
                PNG, JPEG / 1920×1080
              </p>
              <p className="mt-[5px] text-[10px] text-[#515B6B]">
                Min 4 images
              </p>
            </div>
          </div>
        </div>
        {images?.length > 0 &&
          images?.map((img) => (
            <div
              key={img.id}
              className="col-lg-4 col-md-6 col-3 mb-3 p-1 p-sm-auto"
            >
              <div className="md:w-auto h-[80px] md:h-[200px] overflow-hidden relative rounded-lg">
                {loading ? (
                  <SkeletonLoader />
                ) : (
                  <img
                    src={URL.createObjectURL(img.image)}
                    className="h-full w-full object-cover"
                    alt=""
                  />
                )}
                <span
                  className="p-1 cursor-pointer bg-white rounded-[5px] absolute right-[10px] bottom-[10px]"
                  onClick={() => handleDeleteImage(img.id)}
                >
                  <DeleteIcon />
                </span>
              </div>
            </div>
          ))}
      </div>
    </section>
  );
}

export default ImageUpload;
